import React from 'react';
import './Corporate.scss';

function Corporate() {
  return (
    <div className="corporate">
      <nav className="corporate__nav" data-editable="footerLinks" aria-label="nav links">
        <a href="https://www.cnn.com/terms" className="corporate__nav-link">
          Terms of Use
        </a>
        <a href="https://www.cnn.com/privacy" className="corporate__nav-link">
          Privacy Policy
        </a>
        <a href="https://www.cnn.com/?refresh=1#" className="corporate__nav-link">
          Cookie Setting
        </a>
        <a
          href="https://www.warnermediaprivacy.com/policycenter/b2c/WMNS/"
          target="blank"
          className="corporate__nav-link"
        >
          Ad choices
        </a>
        <a href="https://www.cnn.com/accessibility" className="corporate__nav-link">
          Accessibility & CC
        </a>

        <a href="https://www.cnn.com/about" className="corporate__nav-link">
          About
        </a>

        <a href="https://www.cnn.com/newsletters" className="corporate__nav-link">
          Newsletters
        </a>
        <a href="https://www.cnn.com/transcripts" className="corporate__nav-link">
          Transcripts
        </a>
      </nav>
      <p className="corporate__copyright" data-editable="copyrightText">
        © 2023 Cable News Network. A Warner Bros. Discovery Company.{' '}
        <span className="linebreak">All Rights Reserved.</span>
        <br /> CNN Sans ™ &amp; © 2016 Cable News Network.
      </p>
    </div>
  );
}

export default Corporate;
